import { compose } from 'redux'
import { withHandlers } from 'recompose'
import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'
import Locations from './Locations'
import { getPhoneNumberFromObjectWithPrefix, composeFormattedPhoneNumberFromObject } from 'helpers/phone-number'

const withFormattedPhoneDetails = withHandlers({
  getPhoneNumber: () => phoneNumber =>
    composeFormattedPhoneNumberFromObject(phoneNumber),

  getPhoneNumberUrl: () => phoneNumber =>
    getPhoneNumberFromObjectWithPrefix(phoneNumber)
})

export default compose(
  withHandlePhoneLinkClick,
  withFormattedPhoneDetails
)(Locations)
